// Single source of truth for watermark behaviour. Tune here without redeploying logic.
const WATERMARK_CONFIG = {
  enabled: true,
  opacity: 0.08,
  // Tile spacing in CSS px and rotation; ~300x200 ≈ ~40 tiles on a 1080p screen.
  tile: { width: 300, height: 200, rotateDeg: -30 },
  // Patient-facing views (documents and on-screen displays) — must NEVER be
  // watermarked. Matched against the current route name in WatermarkOverlay.
  patientDocDenylist: [
    "PatientWelcomeDisplay",
    "TreatmentPlan",
    "TreatmentHx",
    "MedicalCert",
    "MedicalCertEditor",
    "TreatmentPlanning",
    "DocumentGenerator",
    "ReceiptPreview",
  ],
};

export default WATERMARK_CONFIG;
